{
  "back": "Back",
  "browserConnect": "Browser connect",
  "cancel": "Cancel",
  "closeDialog": "Close dialog",
  "closeErrorAlert": "Close error alert",
  "closeInfoAlert": "Close information alert",
  "connect": "Connect",
  "connectTo": "Connect to",
  "emailAddress": "Email address",
  "enabled": "Enabled",
  "error400": "Error 400 - Our system indicates that the client request sent to our internal servers is invalid or corrupted. Please contact our support team.",
  "error401": "Error 401 - Our system indicates that this account doesn't have permission to perform this action. Please contact our support team.",
  "error500": "Error 500 - We're experiencing some issues with our internal servers and this action can't be performed right now. Please try again later.",
  "error429": "Too many requests - limit reached, please wait 1 hour before trying again",
  "errorFound": "error found",
  "errorsFound": "errors found",
  "missingDetailsError": "Provide the missing details.",
  "next": "Next",
  "no": "No",
  "none": "None",
  "off": "Off",
  "on": "On",
  "other": "Other",
  "password": "Password",
  "pleaseEnterDetails": "Please enter the following details…",
  "pleaseSpecify": "Please specify",
  "readOnly": "Read-only",
  "required": "required",
  "requiredFieldError": "This field is required.",
  "requiredFields": "An asterisk * indicates something is required.",
  "save": "Save",
  "selectAllApply": "Select all that apply",
  "selectOneError": "Select at least one option.",
  "submit": "Submit",
  "userName": "User name",
  "validEmailAddress": "A valid email address is required.",
  "validValueError": "Select a valid value.",
  "vmOpensInANewWindow": "Virtual machine will open in a new window",
  "workEmail": "Work email",
  "yes": "Yes",
  "maxLengthField": "The value entered may not be greater than {{fieldLimit}} characters.",
  "helpSupportHeading": "Contact our dedicated support team",
  "helpSupportParagraph": "For general questions or to provide feedback, please contact our support team. A team member will be happy to assist you.",
  "helpSupportButton": "Contact our support team",
  "helpTrainingHeading": "Training resources",
  "helpTrainingParagraph1": "The Azure learning guide is designed to help you navigate and better understand the different courses and certifications offered by the Microsoft",
  "helpTrainingUrl": "https://esi.microsoft.com/",
  "helpTrainingLink": "Enterprise Skills Initiative",
  "helpTrainingParagraph2": "portal.",
  "helpTrainingButtonHref": "https://github.com/StatCan/cae-eac/raw/master/docs/en/Role-based%20training%20path.pdf",
  "helpTrainingButton": "Azure Learning Guide (PDF, 1.3 MB)",
  "helpAAWParagraph": "Please consult the AAW user guide listed below if you encounter difficulties related to AAW-specific system components or tools. For general concerns and inquiries, please contact the support team for further assistance. A DAS team member will be happy to help you.",
  "helpAAWButton": "AAW user guide",
  "helpCAEParagraph": "Please consult the CAE user guide listed below if you encounter difficulties related to CAE-specific system components or tools. For general concerns and inquiries, please contact the support team for further assistance. A DAS team member will be happy to help you.",
  "helpCAEButton": "CAE user guide",
  "helpGAEParagraph": "Please consult the GAE user guide listed below if you encounter difficulties related to GAE-specific system components or tools. For general concerns and inquiries, please contact the support team for further assistance. A DAS team member will be happy to help you.",
  "helpGAEButton": "GAE user guide",
  "supportHeading": "Contact the support team",
  "supportCategoryLabel": "Help us direct your support request to the right people. Select the category that best fits your support request.",
  "supportCategoryAccount": "Sign in",
  "supportCategoryAAW": "AAW dashboard or tools",
  "supportCategoryCAE": "CAE dashboard or tools",
  "supportCategoryGAE": "GAE dashboard or tools",
  "supportQuestionLabel": "What do you need help with?",
  "feedbackQuestionLabel": "What would you like to tell us?",
  "feedbackRatingLabel": "How has your experience been so far?",
  "feedbackRatingPositive": "Positive",
  "feedbackRatingNeutral": "Neutral",
  "feedbackRatingNegative": "Negative",
  "getStartedBanner": "Once an Account Representative has reviewed this request we will contact you to discuss the next steps in the process.",
  "accountHeading": "Step 1 of 3",
  "accountDescription": "To start this process we need some details about you. Please enter the required details below.",
  "accountFirstName": "First name",
  "accountLastName": "Last name",
  "accountOrganization": "Organization",
  "accountJobTitle": "Job title",
  "accountTypeHeading": "Step 2 of 3",
  "accountTypeBackButton": "Back to step 1",
  "accountTypeLabel": "How can we help you get started with our service? *",
  "accountTypeDesc": "We offer a few options to get started. You can try our service and explore what we offer and/or start a new project if you know what you need.",
  "accountTypeTryService": "Try our service and explore what we offer.",
  "accountTypeNewProject": "Start a new project.",
  "registerHeading": "Step 3 of 3",
  "registerBackButton": "Back to step 2",
  "registerAgree": "I agree to the",
  "registerTerms": "Terms and conditions",
  "registerAnd": "and",
  "registerPrivacy": "Privacy policy",
  "registerResearch": "I would like to participate in future research activities to help Statistics Canada improve their tools and services.",
  "successHeading": "Success",
  "successMessage": "The information provided has been submitted successfully.",
  "successWillContactMessage": "We will contact you within two weeks.",
  "kubeflowRequestNameSpaceTitle": "Request a Kubeflow namespace",
  "kubeflowRequestNameSpaceAfterSubmit": "After submitting the Kuberflow namespace request, an admin will follow up with you with questions or updates.",
  "kubeflowRequestNameSpaceNameFormat": "Please use the following format for the name: \"division-section-project\".",
  "kubeflowRequestNameSpaceLabel": "Namespace name",
  "kubeflowRequestNameSpaceSubmit": "Send request",
  "kubeflowRequestNameSpaceInvalidChars": "The name can only contain the following characters: \"a-z\" (lowercase), \"0-9\", \"-\", or \".\".",
  "kubeflowRequestNameSpaceInvalidFirstChar": "The first character of the name can only be: \"a-z\", or \"0-9\".",
  "kubeflowRequestNameSpaceInvalidLastChar": "The last character of the name can only be: \"a-z\", or \"0-9\".",
  "alertStartedTitle": "Before you get started",
  "alertSignInTitle": "Beta sign up",
  "alertSignIn": "Signing in grants you the ability to:",
  "alertSignInIntroText": "You must be signed in with your Statistics Canada account to begin a project request form.",
  "alertSignInBullet1": "submit project requests",
  "alertSignInBullet2": "make Kubeflow namespace requests.",
  "alertSignInAzureAccount": "Don't have a Statistics Canada associated account?",
  "alertSignInBetaLink": "Sign up for the Beta",
  "alertSignInBeta": "What do you want to try with Data Analytics Services?",
  "alertSignInSuccess": "Thank you for signing up for the Beta!",
  "alertSignInText": "We will contact you with the next steps and additional details to the email you provided.",
  "alertDas": "Powered by Statistics Canada",
  "forgotPasswordHeading": "Confirm password reset",
  "forgotPasswordFirstParagraph": "Are you sure you want to start the password reset process?",
  "forgotPasswordSecondParagraph": "Doing so will send a request to the support team, and you will be notified on the next steps.  Password resets can take up to 2 business days.",
  "successForgotPasswordMessage": "The password reset process has been initiated. Please wait for support to contact you.",
  "vmAmPm": "AM/PM",
  "vmAutoShutdownSettingsFor": "Auto-shutdown settings for",
  "vmEmailAddressForNotifications": "Email address for notifications",
  "vmHour": "Hour",
  "vmMinute": "Minute",
  "vmNotificationMinutesBeforeShutdown": "Notification minutes before auto-shutdown",
  "vmScheduledShutdown": "Scheduled shutdown",
  "vmSendNotificationBeforeAutoShutdown": "Send notification before auto-shutdown?",
  "vmTimeZone": "Time zone",
  "timezonePacific": "(UTC-08:00) Pacific Time",
  "timezoneMountain": "(UTC-07:00) Mountain Time",
  "timezoneCentral": "(UTC-06:00) Central Time",
  "timezoneEastern": "(UTC-05:00) Eastern Time",
  "timezoneAtlantic": "(UTC-04:00) Atlantic Time",
  "timezoneNewfoundland": "(UTC-03:30) Newfoundland",
  "noChangesMessage": "There are no changes to save.",
  "warning": "Warning",
  "autoShutdownEnabled": "Auto-shutdown enabled",
  "sessionExpiredMessage": "Your previous login session has expired.  You will now be logged out.",
  "redirectedMessage": "The previous page can only be accessed after signing in."
}
